import { Form, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { updateUserFormsDetails } from "../../services/awsServices";
import { SIGNUP_FORM_BASIC } from "../../utils/constant";
import toastMessage from "../../utils/toastMessage";
import { uploadDocFun } from "../../utils/utils";
import LoadingModal from "../AllModal/LoadingModal";
import GradientButton from "../Button/GradientButton";
import CurrentInput from "../CurrentInput/CurrentInput";
import FormItem from "../Interactions/FormItem";

const EducationalInformationStep = () => {
  const [formGenerationInfo, setFormGenerationInfo] = useState(
    SIGNUP_FORM_BASIC["Education Information"]
  );
  const [userData, setUserData] = useState({});
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const userAllFormsDetails = useSelector(
    (state) => state.user.userAllFormsDetails
  );

  const basicInfoData = userAllFormsDetails.find(
    (data) => data.SK === "Profile#BasicInfo"
  );

  const btnDisableCond = basicInfoData?.IsFinalSubmit;
  useEffect(() => {
    setLoading(true);
    const educationalInfo = userAllFormsDetails.find(
      (data) => data.SK === "Profile#EducationalInfo"
    );
    console.log("🚀 ~ useEffect ~ educationalInfo:", educationalInfo);

    if (educationalInfo && educationalInfo.Data) {
      const finalObj = {};
      const formGenerArray = [];
      const data = educationalInfo.Data;
      if (data.length > 0) {
        for (let i = 0, n = data.length; i < n; i++) {
          Object.keys(data[i]).forEach((key) => {
            if (key === "CurrentlyStudy") {
              if (typeof data[i][key] === "boolean") {
                console.log("useEffect->Boolean");
                finalObj[`${key + i}`] = [data[i][key]];
              } else {
                finalObj[`${key + i}`] = data[i][key];
              }
            } else {
              finalObj[`${key + i}`] = data[i][key];
            }
          });
          // Assuming formGenerationInfo[0] is defined elsewhere and relevant here
          formGenerArray.push(formGenerationInfo[0]);
        }
      } else {
        formGenerArray.push(formGenerationInfo[0]);
      }

      console.log(finalObj, "=finalObjfinalObjfinalObj:Educ");
      setUserData(finalObj);
      setFormGenerationInfo(formGenerArray);
      // Assuming you have a way to set form fields here
      form.setFieldsValue(finalObj);
    }

    setLoading(false);
  }, [userAllFormsDetails]); // Add dependencies as needed

  const handleSave = (values) => {
    console.log("🚀 ~ handleSave ~ values:", values);
    // console.log(values, " = valuesssss:BasicInformationStep");
    setLoading(true);
    console.log(userData, " = userData:EducationalInformationStep");
    const dataToBeSend = [];
    let allKeys = [
      "InstituteName",
      "QualificationType",
      "DegreeTypes",
      "Grade",
      "Country",
      "City",
      "ProgramName",
      "Year",
      "Major",
      "Certificate",
      "Transcript",
      "Description",
      "CurrentlyStudy",
    ];

    console.log(userData, "===userDatauserDatauserData:Edu");
    // Object.keys(userData).forEach(key => { })
    for (let i = 0, n = Object.keys(userData).length; i < n; i++) {
      if (!userData[`InstituteName${i}`]) {
        break;
      }
      const obj = {};
      allKeys.forEach((key) => {
        if (key === "Certificate") {
          obj[key] = userData[`${key + i}`];
        } else {
          obj[key] = userData[`${key + i}`];
        }
      });
      dataToBeSend.push(obj);
    }
    console.log(dataToBeSend, " = dataToBeSend:EducationalInformationStep");
    const data = {
      SK: "Profile#EducationalInfo",
      Data: dataToBeSend,
    };
    updateUserFormsDetails(data)
      .then((res) => {
        console.log(res.data, "=res:updateEducationalInfo");
        toastMessage(res.data.message, "success");
      })
      .catch((err) => {
        console.log(err, "=err:updateEducationalInfo");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleAddMoreInfo = () => {
    const newArr = [...formGenerationInfo, formGenerationInfo[0]];
    setFormGenerationInfo(newArr);
  };

  const handleChangeInput = async (value, name, index) => {
    if (name.includes("Country")) {
      form.setFieldsValue({ [name]: value, [`City${index}`]: "" });
      setUserData((prev) => ({
        ...prev,
        [name]: value,
        [`City${index}`]: null,
      }));
    } else if (name.includes("Certificate")) {
      setIsFileUploading(true);
      const CertificateRes = await uploadDocFun(value);
      console.log("🚀 ~ handleChangeInput ~ TranscriptRes:", CertificateRes);
      setUserData((prev) => {
        const obj = { ...prev, [name]: CertificateRes };
        console.log(obj, "=====obj:handleSavveeeeeeeeee:");
        return obj;
      });
      setIsFileUploading(false);
    } else if (name.includes("Transcript")) {
      setIsFileUploading(true);
      const TranscriptRes = await uploadDocFun(value);
      setUserData((prev) => {
        const obj = { ...prev, [name]: TranscriptRes };
        return obj;
      });
      setIsFileUploading(false);
    } else {
      form.setFieldsValue({ [name]: value });
      setIsFileUploading(false);
      setUserData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDeleteInfo = (index) => {
    const newArr = formGenerationInfo.filter((_, i) => i !== index);
    setFormGenerationInfo(newArr);

    const newUserData = { ...userData };
    Object.keys(userData).forEach((key) => {
      if (key.includes(index)) {
        delete newUserData[key];
      }
    });
    setUserData(newUserData);
  };

  return (
    <div>
      {loading && <LoadingModal className="bg-gray-500/80" />}
      <p className="text-[18px] font-semibold mt-4 mb-10">
        Educational details
      </p>
      <Form
        onFinish={handleSave}
        form={form}
        initialValues={{}}
        className="w-full mt-8 flex flex-wrap justify-between items-center gap-x-8 gap-y-5"
      >
        {formGenerationInfo?.map((info, index) => {
          return (
            <>
              <div
                key={index}
                className="pb-2 w-full flex flex-col items-center gap-x-8 gap-y-5"
              >
                {info?.map((data, i) => (
                  <FormItem
                    key={i + "-" + index}
                    className={`w-full px-5 sm:px-0 sm:w-full ${
                      data.type === "Checkbox" ? "lg:w-full" : ""
                    } ${data.className}`}
                    name={data.name + index}
                    rules={data.rules}
                  >
                    <p className="text-gray-500 mt-[-4px] pl-1">{data.label}</p>
                    <CurrentInput
                      data={{ ...data, name: data.name + index }}
                      onChange={(value, name) =>
                        handleChangeInput(value, name, index)
                      }
                      formInputData={userData}
                      indexNum={index}
                      value={userData[data.name + index]}
                    />
                  </FormItem>
                ))}
              </div>
              {formGenerationInfo?.length !== index + 1 && (
                <div className="w-full space-y-5">
                  <div className="w-full flex justify-center">
                    <div className="h-[2px] w-[70%] bg-lightOrange/50"></div>
                  </div>
                  <GradientButton
                    type="button"
                    onClick={() => handleDeleteInfo(index)}
                  >
                    Delete
                  </GradientButton>
                </div>
              )}
            </>
          );
        })}
        <div className="w-full flex justify-end">
          <div className="flex flex-col gap-y-2">
            <GradientButton type="button" onClick={handleAddMoreInfo}>
              {/* <span className="">
                <IconPlus />
              </span> */}
              <span>Add More Educational Information</span>
            </GradientButton>
            <Tooltip
              title={
                btnDisableCond
                  ? "Once you click on the 'Final Submission' button, you won't be able to change your details."
                  : ""
              }
            >
              <button
                type="submit"
                disabled={isFileUploading || btnDisableCond}
                className="rounded-full px-16 py-[4px] border-[3px] border-darkOrange hover:border-darkerOrange"
              >
                <span className="text-orange-gradient">
                  {isFileUploading ? "File Uploading..." : "Save Updates"}
                </span>
              </button>
            </Tooltip>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default EducationalInformationStep;
